import axios from '../external/Axios';
import Url from '../constants/Url';

class PayoutApi {
    save(data) {
        return axios
            .post(Url().PAYOUT.SAVE, data)
            .then(response => {
                return response.data.data;
            })
            .catch(ex => {
                console.info('Failed to save:', ex.message);
                throw ex;
            });
    }

    get() {
        return axios
            .get(Url().PAYOUT.GET)
            .then(res => {
                return res.data.data;
            })
            .catch(ex => {
                console.info('Failed to get:', ex.message);
                throw ex;
            });
    }
}

export default new PayoutApi();
